import React from 'react';
export var StepWizard = function (props) {
    var steps = props.steps, currentStep = props.currentStep, setCurrentStep = props.setCurrentStep, stepLabelsOverride = props.stepLabelsOverride;
    var stepLabels = stepLabelsOverride || {
        orderType: 'Order type',
        shop: 'Shop',
        final: 'Create order',
        customer: 'Create customer',
        navOrder: 'Nav order',
        openOrder: 'Open order',
    };
    return (React.createElement("div", { className: "stepwizard" },
        React.createElement("div", { className: "stepwizard-row setup-panel" }, steps.map(function (step, index) {
            return (React.createElement("div", { className: "stepwizard-step col-xs-3", key: index },
                React.createElement("button", { onClick: function () {
                        setCurrentStep(index);
                    }, className: "button button-circle" + (currentStep === steps.indexOf(step) ? ' button-success' : ' button-default')
                        + (steps.length === (index + 1) ? ' last' : '') }, index + 1),
                React.createElement("p", null,
                    React.createElement("small", null, stepLabels[steps[index]]))));
        }))));
};
//# sourceMappingURL=StepWizard.js.map